import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Check } from '@mui/icons-material';
import { useCurrentuser } from '@uplift/contexts';
import { UserRole } from '@uplift/types';
import React, { useMemo } from 'react';

export type VerificationTagProps = {
  verified: boolean;
};

export const VerificationTag: React.VFC<VerificationTagProps> = ({ verified }) => {
  const { classes } = useStyles();
  const me = useCurrentuser();

  const label = useMemo(() => {
    if (verified) {
      return 'Verified';
    }
    if (me?.role === UserRole.superadmin && !verified) {
      return 'Unverified';
    }
    return null;
  },[ me?.role, verified ]);

  return (
    <Box className={classes.verification}>
      {verified && <Check fontSize="small" color="primary" />}
      <Typography variant="body1" color="textSecondary" style={{ fontWeight: 'initial' }}>{label}</Typography>
    </Box>
  );
};

const useStyles = makeStyles()(theme => ({
  verification: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gridGap: theme.spacing(.5),
  },
}));
